import { render, staticRenderFns } from "./paymentRecord.vue?vue&type=template&id=4edd31be&scoped=true&"
import script from "./paymentRecord.vue?vue&type=script&lang=js&"
export * from "./paymentRecord.vue?vue&type=script&lang=js&"
import style0 from "./paymentRecord.vue?vue&type=style&index=0&id=4edd31be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd31be",
  null
  
)

export default component.exports